<template>
	<section>
		<HeaderForm title="Tambah Kontak" note="pelanggan"/>
		
		<Form />
	</section>
</template>

<script>
import HeaderForm from '@/components/HeaderForm'
import Form from './components/Form'
export default {
	name: 'ContactAdd',
	components: {
		HeaderForm,
		Form
	}
}
</script>